import { createBrowserRouter, createRoutesFromElements, Route } from "react-router-dom";
import { AuthLayout } from "@/routes/layouts/AuthLayout/AuthLayout";
import { RootLayout } from "@/routes/layouts/RootLayout/RootLayout";
import { SearchPage } from "@/pages/Search/SearchPage";
import { DocumentPage } from "@/pages/Document/DocumentPage";
import * as Sentry from "@sentry/react";

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);

export const AppRouter = sentryCreateBrowserRouter(
  createRoutesFromElements(
    <Route path={"/"} element={<RootLayout />}>
      {/*  Private Rote*/}
      <Route element={<AuthLayout />}>
        <Route index element={<SearchPage />} />
        <Route path={"/documents/:documentId"} element={<DocumentPage />} />
      </Route>
      {/*  Public Route*/}
      {/*<Route></Route>*/}
    </Route>,
  ),
);
